import { RouteHandler } from 'wee-routes';
import $ from 'wee-dom';
import $events from 'wee-events';
import $location from 'wee-location';
import $fetch from 'wee-fetch';
import { $setRef } from 'core/dom';
import { _win } from 'core/variables';
import Tweezer from 'tweezer.js';
import question from '../faq/question';

class Filter {
    constructor() {
        this.$filter = $(':filter');
        this.$container = $(':filteredItems');
        this.filterType = this.$filter.data('type');
        this.origin = $location.uri().origin;
        this.category = $location.uri().query.category;

        this.bindEvents();
    }

    bindEvents() {
        $events.on(':categoryLink', 'click', (e, el) => {
            this.filter($(el).data('category'));

            e.preventDefault();
        });
    }

    /**
     * Update url and filter items
     */
    filter(cat) {
        $fetch.get(`${this.origin}/ajax/${this.filterType}`, {
            responseType: 'text',
            params: {
                category: cat,
            },
        }).then(({ data }) => {
            this.$container.html(data);

            if (this.filterType === 'faq') {
                question.init();
            }

            $setRef();

            this.bindEvents();

            const url = `/${this.filterType}`;

            _win.history.replaceState({
                path: url,
            }, null, url + (cat === 'all' ? '' : `?category=${cat}`));

            new Tweezer({
                start: $(_win).scrollTop(),
                end: this.$container.offset().top,
                duration: 500,
            }).on('tick', (value) => {
                _win.requestAnimationFrame(() => _win.scrollTo(0, value));
            }).begin();
        }).catch(e => console.error(e));
    }
}

export default new RouteHandler({
    init() {
        const filter = new Filter();

        $events.on({
            [filter.$filter.sel]: {
                change(e, el) {
                    filter.filter(el.value);
                },
            },
        }, {
            delegate: ':filteredItems',
        });
    },
});
